import { useUserIdContext } from "~/context/useUserIdContext";

const useUserId = () => {
    return useUserIdContext();
};

export default useUserId;
